/* eslint-disable no-console */
<template>
  <div class="display-box-page box_wrap_big">
    <div class="scroll-box">
      <el-main>
        <el-table
          class="twj-table"
          :data="tableData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :row-style="getRowClass"
          :header-row-style="getRowClass"
          :header-cell-style="getRowClass"
          :cell-style="cellStyle"
        >
          <el-table-column
            align="left"
            prop="orderCode"
            label="运单单号"
            width="150"
            show-overflow-tooltip
          />
          <el-table-column
            align="left"
            prop="vehicleLicense"
            width="100"
            label="车牌号"
            show-overflow-tooltip
          />
          <!-- <el-table-column
            align="left"
            prop="fleet_name"
            label="运输车队"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            align="left"
            prop="workPoint"
            label="起始地"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.shipperCity + scope.row.shipperArea }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="storehouseName"
            label="目的地"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.consigneeCity + scope.row.consigneeArea }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="weight"
            label="总重量(吨)"
            width="160"
            show-overflow-tooltip
          />
          <el-table-column
            align="left"
            prop="mileage"
            label="总里程(km)"
            width="120"
            show-overflow-tooltip
          />
          <el-table-column
            align="left"
            prop="leftMileage"
            label="剩余里程(km)"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.leftMileage || "0" }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="sendLoadLocationTime"
            label="装车时间"
            width="110"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.sendLoadLocationTime | setTime }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="planArriveTime"
            label="计划到达"
            width="110"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.planArriveTime | setTime }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="estimateArriveTime"
            label="预计到达"
            width="110"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.estimateArriveTime | setTime }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            width="110"
            prop="delayFlag"
            label="运行状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div
                :class="{
                  specialColor: scope.row.delayFlag == '0',
                  redColor: scope.row.delayFlag == '1'
                }"
              >
                {{ scope.row.delayFlag == "0" ? "正常" : "延误" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="status"
            label="订单状态"
            width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.status == "1"
                    ? "待运输"
                    : scope.row.status == "2"
                      ? "运输中"
                      : scope.row.status == "3"
                        ? "已到达"
                        : scope.row.status == "4"
                          ? "已到达"
                          : scope.row.status == "5"
                            ? "已到达"
                            : "--"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            width="100"
            prop="delayTime"
            label="延误时间"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.delayTime || "--" }}
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            align="left"
            prop="progress"
            label="进度"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.progress + "%" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="left" label="轨迹">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="
                  font-family: PingFang SC, PingFang SC;
                  color: #c29c3d;
                  font-size: 16px;
                "
                size="small"
                @click="handleClick(scope.row)"
              >查看轨迹</el-button>
              <!-- <el-button type="text" style="color: #01C2FF;font-size: 16px;" size="small">视频</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    setTime(e) {
      // let time = new Date(e);
      return e ? e.substring(5, 16) : "--";
      // (
      //   time.getMonth() +
      //   1 +
      //   "-" +
      //   time.getDate() +
      //   " " +
      //   time.getHours() +
      //   ":" +
      //   time.getMinutes()
      // );
    },
    conversionTime(e) {
      let time = Math.floor(e);
      if (time > 60 && time < 60 * 24) {
        return time / 60 + "小时" + (time % 60) + "分钟";
      } else if (time > 60 * 24) {
        let hour = Math.floor(time / 60);
        let min = time % 60;
        let hours = hour % 24;
        let day = Math.floor(hour / 24);
        return day + "天" + hours + "小时" + min + "分钟";
      } else if (time > 0) {
        return time + "分钟";
      }
      return "";
    }
  },
  props: ["tableData"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background: rgba(9, 22, 45)!important;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;font-size: 18px;color: #E6EBEE;text-align: center;";
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log("123",row, rowIndex)
      if (row.order_status == "延误") {
        return "abnormal";
      }
      return "success-row";
    },
    cellStyle() {
      return "color:#ffffff;font-size: 15px;text-align: center;";
    },
    handleClick(info) {
      this.$emit("handleClick", info);
    }
  }
};
</script>
<style lang="scss">
.box_wrap_big {
  .el-table {
    tbody tr {
      height: 64px;
      background-color: rgba(9, 22, 45) !important;
      &:hover {
        background-color: rgba(9, 22, 45) !important;
        & > td {
          background-color: rgba(9, 22, 45) !important;
        }
      }
    }
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(9, 22, 45) !important;
  }
}
</style>
<style lang="scss" scoped>
.twj-table td,
.twj-table th.is-leaf {
  border-bottom: 1px solid #e7f8fc1e !important;
}

.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  max-width: 60% !important;
  color: #000;
  font-size: 16px;
  background-color: rgb(255, 255, 255) !important;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: rgba(255, 255, 255, 0.1);
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: rgba(255, 255, 255, 0.1);
}

.el-table .warning-row {
  background: oldlace;
}

// .el-table .success-row {
//   background: #091c2c;
// }
// .el-table .abnormal {
//   background: #2a3d4b;
// }
/* 如果你还想要设置表格的tr透明，并且有鼠标悬浮效果，可以这样做 */

/* 设置el-table的透明背景 */
.el-table {
  background: #09162d !important;
  box-shadow: inset 0px 0px 30px 0px #3064c8;
  border: 1px solid rgba(37, 156, 220, 0.613);
  opacity: 0.8;
}

.display-box-page {
  width: 100%;
  // background: #091c2c;
}
.operation {
  color: #01c2ff;
}
.specialColor {
  // color: #4cc672;
  width: 44px;
  height: 23px;
  background: #47ae5d;
  border-radius: 3px 3px 3px 3px;
  color: #fff;
  margin: auto;
}
.wordColor {
  width: 44px;
  height: 23px;
  background: #f4b366;
  border-radius: 3px 3px 3px 3px;
  color: #fff;
  margin: auto;
}
.redColor {
  width: 44px;
  height: 23px;
  background: #cb3229;
  border-radius: 3px 3px 3px 3px;
  color: #fff;
  // color: #fc5750;
  margin: auto;
}
.redColor2 {
  color: #fc5750;
}
</style>

/* eslint-enable no-console */
